export default "__VITE_IMAGE_ASSET__3c39cdd5__";